export class InvestedFund {
  id: number = null;
  name: string = null;
  document: string = null;
  administrator: string = null;
  fundClass: string = null;
  series: string = null;
  mnemonicCode: string = null;
  isFIDC = false;
  scheme: string;
  sourceId: string = null;
  isManualSettlementDate: boolean = null;
  allowEmptyAccount: boolean = false;
}
